import type { TFunction } from "i18next";
import type { TaskRow } from "./api";

/** Only this known machine-authored task uses an i18n key as its stored title. */
export function taskDisplayTitle(task: Pick<TaskRow, "kind" | "title">, t: TFunction): string {
  return task.kind === "matrix_approval.hr_review_required" && task.title === "org.matrixApproval.hrReviewRequired"
    ? t("org.matrixApproval.hrReviewRequired") : task.title;
}
